import { CardsTutorial } from "./cards-tutorial";

export function PageTutorial() {

  return (
    <><div id="page-tutorial" className="mt-10 flex flex-col items-center justify-center">
      <h1>Área de Tutoriais</h1>
    </div>
      <section>
        <div>
          <CardsTutorial />
        </div>
      </section></>
  )
}